import { ColumnFiltersState, OnChangeFn, SortingState } from '@tanstack/react-table';

export enum SignsTableMode {
  MAP = 'MAP',
  TABLE_AND_MAP = 'TABLE_AND_MAP',
  TABLE = 'TABLE',
}

export type SignsTableState = {
  mode: SignsTableMode;

  globalFilter: string;
  includeAdditional: boolean;
  columnFilters: ColumnFiltersState;
  sorting: SortingState;

  actions: {
    setMode: (mode: SignsTableMode) => void;
    expandModeMap: () => void;
    expandModeTable: () => void;

    setGlobalFilter: (globalFilter: string) => void;
    setIncludeAdditional: (includeAdditional: boolean) => void;
    setColumnFilters: OnChangeFn<ColumnFiltersState>;

    setSorting: (sorting: SortingState) => void;
  };
};
